import Vue from 'vue';
// import Vuex from 'vuex';
// Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        //路由组件存储器
        routers: {},
        invoice: {
            channelType: null,
            orderId: [],
            amount: 0,
            companyId: []
        },
        cityCode: null,
        carDamageImgType: '', // 车务连拍照片类型string outside - 外观，inspect-内饰 other-其他
        activityPart: '', // 车务车损，正在操作的外观部位名称(id)
        outsideImageList: [], // 车务连拍外观问题照片
        inspectImageList: [], // 车务连拍内饰问题照片
        otherImageList: [], // 车务连拍其他问题照片
        sign_list: [], // 手写签名合同id列表
        isfirst_login: 0,
    },
    getters: {
        routers: state => {
            return state.data;
        }
    },
    actions: {
        // 保存车务车损拍照信息
        setCarDamageList({ dispatch, commit }, params) {
            commit('SET_CAR_DAMAGE_LIST', params)
        },
    },
    mutations: {
        //动态增加路由
        addRouter: (state, data) => {
            state.routers = Object.assign({}, state.routers, {
                [data.name]: data.component
            });
        },
        setTripInvoice: function (state, tripInvoice) {
            state.invoice.channelType = tripInvoice.channelType
            state.invoice.orderId = tripInvoice.orderId
            state.invoice.businessType = tripInvoice.businessType
            state.invoice.businessId = tripInvoice.businessId
            state.invoice.amount = tripInvoice.amount
            state.invoice.companyId = tripInvoice.companyId
        },
        setChargeInvoice: function (state, chargeInvoice) {
            state.invoice.channelType = chargeInvoice.channelType
            state.invoice.orderId = []
            state.invoice.amount = chargeInvoice.amount
        },
        setCityCode: function (state, personalInfo) {
            state.cityCode = personalInfo.cityCode
        },
        // 车务连拍照片类型
        SET_CAR_DAMAGE_IMG_TYPE(state, data){
            state.carDamageImgType = data
        },
        // 车务连拍车损部位名称
        SET_CAR_DAMAGE_IMG_PART(state, data){
            state.activityPart = data
        },
        // 删除车务车损单个照片(内饰或其他)
        DEL_ONE_IMAGE(state, params) {
            console.log('DEL_ONE_IMAGE')
            if(params.type === 'inspect') {
                state.inspectImageList.splice(params.index, 1)
            } else if (params.type === 'other') {
                state.otherImageList.splice(params.index, 1)
            }
        },
        // 保存车务车损拍照信息
        SET_CAR_DAMAGE_LIST(state, data) {
            if(state.carDamageImgType === 'outside') { // 外观
                const partIndex = state.outsideImageList.findIndex(item => item.damagePart === state.activityPart)
                console.log('state.outsideImageList:', state.outsideImageList)
                console.log('partIndex:', partIndex)
                if(partIndex > -1) {
                    state.outsideImageList.splice(partIndex, 1, {
                        damageType: 'APPEARANCE', // 损伤类型
                        damagePart: state.activityPart, // 损伤部位
                        damagePhotoUrlList: data // 损伤照片列表
                    })
                } else {
                    state.outsideImageList.push({
                        damageType: 'APPEARANCE', // 损伤类型
                        damagePart: state.activityPart, // 损伤部位
                        damagePhotoUrlList: data // 损伤照片列表
                    })
                }
            console.log('state.outsideImageList1:', state.outsideImageList)
            } else if (state.carDamageImgType === 'inspect') { // 内饰
                state.inspectImageList = data
            } else if(state.carDamageImgType === 'other') { // 其他
                state.otherImageList = data
            }
        },
        // 初始化车务车损信息store中数据（原生如果提供一个跳转页面bridge,就不用写这个方法了）
        SET_CAR_DAMAGE_INFO_DEFAULT(state){
            state.carDamageImgType = ''
            state.activityPart = ''
            state.outsideImageList = []
            state.inspectImageList = []
            state.otherImageList = []
        },
        // 保存整租V2手写签名中的list
        SET_SIGN_LIST(state,data) {
            state.sign_list = data
        },
        // 是否第一次进入页面
        SET_FIRST_LOGIN(state, data) {
            state.isfirst_login = data
        }
    },
})

//根目录中注册路由组件
window.midea = {
    registerRouter(name, component) {
        Store.commit('addRouter', {
            name: name,
            component: component
        })
    }
}; //页面使用路由导航



// WEBPACK FOOTER //
// src/store/index.js